import { useViewEvent } from '@stitch-fix/event-reporter';
import { Box, Text } from '@stitch-fix/mode-react';
import type { GetLookbookGalleryQuery } from '../graphql/getLookbookGallery';
export type GalleryQuickActionData = NonNullable<NonNullable<GetLookbookGalleryQuery['client']>['vision']['galleryQuickActionModule']>;
export interface GalleryQuickActionProps {
  module: GalleryQuickActionData;
}
export const GalleryQuickAction = ({
  module
}: GalleryQuickActionProps) => {
  const {
    EventProvider,
    ref
  } = useViewEvent({
    content_id: module.contentId,
    name: 'quick_action',
    schema: 'view'
  });
  return <EventProvider>
      <Box ref={ref} data-testid="quick-action-card-mint" bgColor="mint-60" px={1.5} py={1} style={{
      borderRadius: '8px'
    }}>
        {module.eyebrow ? <Text setting="eyebrow-small" color="blue-45" align="left" mb={0.5}>
            {module.eyebrow}
          </Text> : null}
        <Text setting="title-medium" color="blue-45" align="left">
          {module.title}
        </Text>
      </Box>
    </EventProvider>;
};